<template>
    <t-space direction="vertical" style="overflow: hidden; background: url('../A.jpg');">
        <t-layout  style="height: 99.7vh; width: 99.9vw; background-color: rgba(0, 0, 0, 0);">
            <t-header style="background-color: rgba(0, 0, 0, 0);">
                <t-row style="height: 100%;" align="middle">
                    <t-col span="10" style="height: 100%; background-color: rgba(0, 0, 0, 0);">
                        <t-space direction="horizontal">
                            <!-- <t-row>
                                <t-col>
                                    <t-image
                                    src="logo.png"
                                    style="width: 3vw; height: 2.5vh; background-color: rgba(0, 0, 0, 0);"/>
                                </t-col>
                            </t-row> -->
                        </t-space>
                    </t-col>
                    <t-col span="1">
                        <!-- <t-row>
                            <t-col span="4"></t-col>
                            <t-col span="4" align="end"></t-col>
                            <t-col span="4" align="end">
                                <t-tooltip content="帮助说明">
                                    <icon-font name="chat-bubble-help" size="large"/>
                                </t-tooltip>
                                
                            </t-col>
                        </t-row> -->
                        
                    </t-col>
                </t-row>
            </t-header>
            <t-layout style="height: 80vh; background-color: rgba(0, 0, 0, 0);">
                <t-aside style="height: 100%; background-color: rgba(0, 0, 0, 0);"> 
                    <t-row style="height: 100%;">
                        <t-col span="6" style="height: 100%;">
                            <t-space  direction="vertical" :size="spaceSize" style="width: 50vw; padding-left: 3vw;">
                                <t-space></t-space>
                                <t-space  direction="vertical" size="small" > 
                                    <t-typography-title level="h1">
                                        欢迎登录到
                                        <br/>
                                        闪仓Flash Warehouse
                                    </t-typography-title>
                                    <t-typography-text theme="secondary" italic>
                                        闪仓 Flash warehouse
                                    </t-typography-text>
                                </t-space>
                                <t-space direction="vertical" :size="30" style="width: 20vw;">
                                    <t-input    type="text" 
                                                size="large"
                                                placeholder="请输入用户名/手机号" 
                                                :prefix-icon="userIcon" 
                                                :value="userName" 
                                                @change="userNameChange"/>
                                    <t-input    type="password"  
                                                size="large"
                                                placeholder="请输入密码" 
                                                :prefix-icon="lockIcon" 
                                                :value="password" 
                                                @change="passwordChange"/>
                                    <t-button   style="width: 100%;" 
                                                size="large"
                                                @click="Login">
                                                登录
                                    </t-button>
                                </t-space>
                            </t-space>
                        </t-col>
                        <t-col span="6" style="height: 100%;">
                        </t-col>
                    </t-row>
                </t-aside>
            </t-layout>
            <div  class="bottom">
                @ jhsc.top 版权所有ICP证：<a href="https://beian.miit.gov.cn/" target="_blank" style="color: #888">陇ICP备2024007504号-2</a>
            </div>
            
        </t-layout> 
    </t-space>
</template>

<script  lang="jsx" setup>
import router from '@/router/main';
import axios from 'axios';
//import { IconFont } from 'tdesign-icons-vue-next';
import { UserIcon,LockOnIcon } from 'tdesign-icons-vue-next';
import { onMounted, ref } from 'vue';
import { NotifyPlugin } from 'tdesign-vue-next';
import request from '@/request/request';
const userIcon = () => <UserIcon/>;
const lockIcon = () => <LockOnIcon/>;

const spaceSize = ref(60)
const userName = ref("")
const password = ref("")

onMounted(()=>{
    let user_id = sessionStorage.getItem("user_id")
    if(user_id) {
        router.push("/home")
    }
})
const userNameChange = (val)=>{
    userName.value = val
}
const passwordChange = (val)=>{
    password.value = val
}
const Login = ()=>{
    axios({
            method:"GET",
            url:"flash_warehouse/user/login",
            params:{
                user_name:userName.value,
                phone_number: userName.value,
                password:password.value
            }
        })
    .then((result)=>{
        let result_data = result.data
        if(result_data.success) {
            console.log(result_data)
            sessionStorage.setItem("user_id",result_data.data)
            request.ReadBillOfDocumentConfig()
            request.RequestGetUserInfo(result_data.data,(res)=>{
                if(res.data.success) {
                    sessionStorage.setItem("user_info",JSON.stringify(res.data.data))
                }else {
                    NotifyPlugin.error({
                        placement: 'top-right',
                        title: '用户数据请求错误',
                        content: '用户数据请求失败，其联系管理人员',
                        duration: 3000,
                    })
                }
            },(err)=>{
                NotifyPlugin.error({
                    placement: 'top-right',
                    title: '用户数据请求错误',
                    content: '用户数据请求失败，其联系管理人员' + err,
                    duration: 3000,
                })
            })
            router.push("/home")
        }else{
            NotifyPlugin.info({
                placement: 'top-right',
                title: '登录失败',
                content: '请检测所输入的用户名/手机号，以及密码',
                duration: 3000,
            })
        }
    }).catch((err)=>{
        NotifyPlugin.info({
                placement: 'top-right',
                title: '登录失败',
                content: err,
                duration: 3000,
            })
    })
}

</script>

<style scoped>
    .bottom {
        width: 100vw;
        text-align: center;
        color: #888;
    }
</style>